<template>
    <Card :title="$t('inventory.inventoryTable')">
        <div class="card-body">
            <router-link class="btn btn-link" :to="{ name: 'CreateInventoryPage' }">
                <i class="icon-plus3 mr-2"></i>
                {{ $t('buttons.create') }}
            </router-link>
        </div>
        <DataTable
            ref="DataTable"
            :config="table.config"
        >
            <template #cell-id="{item}">
                <Paragraph>
                    <template #title>
                        <router-link :to="{ name: 'EditInventoryPage', params: { inventoryUuid: item.uuid } }">{{ item.id }}</router-link>
                    </template>
                </Paragraph>
            </template>
            <template #cell-status="{item}">
                <span class="badge" :style="{
                    background: item.status.color,
                    color : 'white'
                }">{{ item.status.name }}</span>
            </template>
            <template #cell-product_items_count="{item}">
                <span>{{ item.product_items_count }}</span>
            </template>
            <template #cell-created_at="{item}">
                <span>{{ DateFormatter.formatDateTime(item.created_at) }}</span>
            </template>
        </DataTable>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue'
import DataTable from '../../../../components/new/datatable/DatatableComponent.vue'
import pageData from './data.json'
import Paragraph from "../../../../components/table/ParagraphComponent.vue"
import DateFormatter from '../../../../services/DateFormatter.ts'

export default {
    name: "IndexInventoriesPage",
    components: {
        Card, DataTable, Paragraph
    },
    data() {
        return {
            DateFormatter,
            table: {
                config: pageData.table,
            }
        }
    },
    watch: {
        '$route.query.template'(newTemplate) {
            this.table.config.templateUuid = newTemplate ?? null;
            this.$refs.DataTable.reload();
        }
    },
    mounted() {
        this.$refs.DataTable.load();
    },
    beforeMount() {
        this.table.config.templateUuid = this.$route.query.template;
    },
    beforeUnmount() {
        this.table.config.filters.forEach((filter) => {
            filter.default = 0;
        });
        this.table.config.templateUuid = null;
    }
}
</script>
